/**
 * Carril contextual (GEN-PX-023): el carril junto al raíl lista las entradas hijas del botón pulsado.
 * Los hijos los decide el kernel (R-PT-02/R-PT-04): cada ítem del menú puede traer `hijos: [{id, label}]`, ya filtrados por
 * perfil. El front solo los lee y los pinta; no decide quién ve qué. Un botón sin hijos no tiene sección.
 */

const usable = m => !!m && m.visible !== false && m.enabled !== false

/**
 * RESPALDO TEMPORAL (GEN-PX-023): el Pórtico se despliega al fusionar y el kernel espera al pipeline. Mientras el kernel no
 * emita `hijos`, los hijos de cada botón se derivan de lo que el kernel ya emitía (los ítems que la gestión ya recibía y, en
 * Auditoría, `pestanas`). Con `hijos` presentes, manda el kernel.
 */
const RESPALDO = {
  admin: menu => [
    ['herramientas', 'Herramientas'], ['modelos', 'Modelos'], ['libro-de-estilo', 'Marca y estilo'], ['coste', 'Coste'], ['salud', 'Salud'],
  ].filter(([id]) => menu.some(m => m.id === id && usable(m))).map(([id, label]) => ({ id, label })),
  auditoria: (menu, item) => (Array.isArray(item.pestanas) ? item.pestanas : []),
  // «Perfiles» (mapa de permisos) es provisional; sin él, Agentes no tenía submenú.
  agentes: menu => (menu.some(m => m.id === 'equipo' && usable(m)) && menu.some(m => m.id === 'agentes-permisos' && usable(m))
    ? [{ id: 'equipo', label: 'Equipo' }, { id: 'agentes-permisos', label: 'Perfiles' }]
    : []),
}

/** Hijos de un ítem del menú: los del kernel; sin ellos, el respaldo temporal. Siempre una lista. */
export function hijosDe(item, menu = []) {
  if (!item) return []
  if (Array.isArray(item.hijos)) return item.hijos
  return RESPALDO[item.id]?.(menu, item) ?? []
}

/**
 * Sección del carril para la vista pedida, o null si el botón no tiene hijos (el carril no cambia).
 *  - `vista` es un botón con hijos: abre el hijo `sub`, o el primero.
 *  - `vista` es una entrada hija pedida por su id (ruta oculta): resuelve su botón.
 *    Un id que ya tiene botón propio en el raíl (`botones`) nunca se reinterpreta como hijo de otro.
 * Devuelve { padre, hijos, activo }.
 */
export function seccionDe(menu = [], vista, sub = null, botones = []) {
  const conHijos = m => usable(m) && hijosDe(m, menu).length > 0
  let padre = menu.find(m => m.id === vista && conHijos(m))
  let pedido = sub
  if (!padre && !botones.includes(vista)) {
    padre = menu.find(m => conHijos(m) && hijosDe(m, menu).some(h => h.id === vista))
    pedido = vista
  }
  if (!padre) return null
  const hijos = hijosDe(padre, menu)
  return { padre, hijos, activo: hijos.find(h => h.id === pedido) ?? hijos[0] }
}
